import React from 'react';

interface CapricornLogoProps {
  className?: string;
}

export const CapricornLogo: React.FC<CapricornLogoProps> = ({ className }) => {
  return (
    <svg
      viewBox="0 0 182 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Capricorn"
    >
      <image href="/capricorn-symbol.svg" width="42" height="40" />
      <text
        x="47"
        y="29"
        fill="#9AEEE6"
        fontFamily="Instrument Sans, sans-serif"
        fontSize="31"
        fontWeight="400"
        letterSpacing="-1"
        textLength="133"
        lengthAdjust="spacingAndGlyphs"
      >
        Capricorn
      </text>
    </svg>
  );
};
